import backend from './backend';

const endpoint = '/uber/config';

export default {
    get(){
        return backend.get(endpoint).then(response => response.data)
    }
}